import { Property } from '@/models/Property'
import { Client } from '@/models/Client'
/* eslint-disable camelcase */
export class Visit {
  id: string
  office_id: string
  client_id: string
  user_id: string
  property_id: string
  notes: string
  client: Client
  property: Property
  completion_date: string

  constructor(data: any = {}) {
    this.id = data.id || null
    this.office_id = data.office_id || null
    this.client_id = data.client_id || null
    this.user_id = data.user_id || null
    this.property_id = data.property_id || null
    this.notes = data.notes || null
    this.property = data.property || null
    this.client = data.client || null
    this.completion_date = data.completion_date || null
  }
}
